import { formatFixed } from "../components/charts/format";

// A variacao de um numero contra o periodo anterior (spec do redesign, R5). Uma contagem varia em
// percentagem relativa, uma percentagem em pontos percentuais, e um numero simples (`kind: "number"`, os
// "por 100 cartoes") na diferenca, sem unidade. Sem base (anterior a null, ou zero numa contagem) nao ha
// variacao: `text` a null, e quem desenha diz "sem comparacao". O tom segue o sentido de cada numero:
// `better` e "up" (mais e melhor), "down" ou "neutral" (so contexto). O sinal vai no texto, para a cor
// nunca ser a unica pista; uma variacao que arredonda a zero nao tem sinal nem cor ("0,0 p.p.").
const MINUS = "−";
const UNITS = { count: "%", percent: " p.p.", number: "" };

// A variacao que nao ha: tambem a de um anterior que os dados so cobrem em parte (previousIsComplete).
export const NO_COMPARISON = { text: null, tone: "none" };

const toneOf = (change, better) => {
  if (change === 0 || better === "neutral") return "neutral";
  return (change > 0) === (better === "up") ? "good" : "bad";
};

export const variation = ({ kind, value, previous, better = "up", digits = 1 }, language) => {
  if (value === null || previous === null || previous === undefined || (kind === "count" && previous === 0)) {
    return NO_COMPARISON;
  }
  const raw = kind === "count" ? ((value - previous) / previous) * 100 : value - previous;
  const change = Number(raw.toFixed(digits));
  const sign = change === 0 ? "" : change < 0 ? MINUS : "+";
  return {
    text: `${sign}${formatFixed(Math.abs(change), digits, language)}${UNITS[kind]}`,
    tone: toneOf(change, better),
  };
};
